import cloneDeep from 'lodash/cloneDeep';

const validator = {
  fieldIsValid(key, val) {
    if (val === undefined) { return false; }
    if (key === 'email') {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val);
    }
    return val.length > 0 && val.length <= 255;
  },

  validate(state, toBeValidated) {
    const object = cloneDeep(state); // Deep clone state and keep files
    object.isValid = true;
    toBeValidated.forEach((key) => {
      object[`${key}Error`] = false;
      if (!this.fieldIsValid(key, object[key])) {
        object.isValid = false;
        object[`${key}Error`] = true;
      }
    });
    return object;
  },
};

export default validator;



// WEBPACK FOOTER //
// ./src/services/validator.js